export { isFactorTrendMetric } from './factorUtils';
